import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetPhysicalDistributionSectionTemplate,
  usePutPhysicalDistributionTemplate,
} from 'services/templates/physical-distribution-template';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditPhysicalDistributionSectionTemplate = () => {
  const id = useParamId('/templates-extended');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const physicalDistribution = useGetPhysicalDistributionSectionTemplate(id);

  const updatePhysicalDelivery = usePutPhysicalDistributionTemplate(id);

  const goBackToPhysicalDistribution = () =>
    navigate(`/templates-extended/physical-distribution/${id}/form`);

  const onUpdatePhysicalDistributionSection = async (
    values: IContractTemplateForm,
    formikHelpers: FormikHelpers<IContractTemplateForm>
  ) => {
    const distribution = middleware.template.physicalDistribution.formToQuery(values);

    if (distribution) {

      await updatePhysicalDelivery.mutateAsync(distribution, {
        onSuccess: goBackToPhysicalDistribution,
        onError: error => onErrorShowAllErrorsToast(error),
      });
    }
  };

  return (
    <Form.Contract
      tittle={`${t('button.edit')} ${
        physicalDistribution.data?.title ??
        t('contract-template.physicalDistribution.title')
      }`}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToPhysicalDistribution}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t(`button.save`)} />
        </Button>
      }
      initialStatus={contractTemplateUtil.distribution.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: physicalDistribution.data
          ? middleware.template.physicalDistribution.queryToForm(
              physicalDistribution.data,
              '1',
              true,
              true
            )
          : contractTemplateUtil.distribution.initialValues(TEMPLATE_TYPE.physicalDistribution),
      }}
      onSubmit={onUpdatePhysicalDistributionSection}
      status={{ isLoading: physicalDistribution.isLoading }}
    />
  );
};

export default EditPhysicalDistributionSectionTemplate;
